import bboxPolygon from '@turf/bbox-polygon'
import { points } from '@turf/helpers'
import pointsWithinPolygon from '@turf/points-within-polygon'

import GetMapExtents from 'map/GetMapExtents'

/**
 * Get extents coords in correct order and format for the openlayers view extents params.
 * https://openlayers.org/en/latest/apidoc/module-ol_View-View.html
 *
 * @param {array} point [lng4326,lat4326]
 * @param {array} bbox [lng4326,lat4326,lng4326,lat4326]
 */
export default function (point, bbox) {
  try {
    const bReturn4326Coords = true
    const extents = GetMapExtents(bbox, bReturn4326Coords)
    const pts = points([point])
    const searchWithin = bboxPolygon(extents)
    const ptsWithin = pointsWithinPolygon(pts, searchWithin)
    if (ptsWithin && ptsWithin.features && ptsWithin.features.length > 0) {
      console.log('Point in bounding box.')
      return true
    }
  } catch (e) {
    console.log('Failed to find point, error', e)
    return false
  }
  console.log('Point not in bounding box.')
  return false
}
